// Event delegation setup to replace inline onclick handlers
// This file sets up all event listeners using delegation pattern

export function setupEventDelegation() {
    // Get the main document body for delegation
    const body = document.body;
    
    // Email Verification Banner events
    body.addEventListener('click', (e) => {
        // Dismiss email banner button
        if (e.target.closest('[data-action="dismiss-email-banner"]')) {
            window.dismissEmailBanner();
            return;
        }
        
        // Resend verification email button
        if (e.target.closest('[data-action="resend-verification"]')) {
            window.resendVerificationEmail();
            return;
        }
        
        // Check email status button
        if (e.target.closest('[data-action="reload-page"]')) {
            window.location.reload();
            return;
        }
        
        // Logo click to scroll to top
        if (e.target.closest('[data-action="scroll-to-top"]')) {
            window.scrollToTop();
            return;
        }
        
        // Mobile menu toggle
        if (e.target.closest('[data-action="toggle-mobile-menu"]')) {
            window.toggleMobileMenu();
            return;
        }
        
        // Show helpers link
        if (e.target.closest('[data-action="show-helpers"]')) {
            e.preventDefault();
            window.showHelpers();
            return;
        }
        
        // Hero buttons
        if (e.target.closest('[data-action="handle-seeker"]')) {
            window.handleSeekerClick();
            return;
        }
        
        if (e.target.closest('[data-action="handle-helper"]')) {
            window.handleHelperClick();
            return;
        }
        
        // Filter buttons
        const filterBtn = e.target.closest('[data-filter]');
        if (filterBtn) {
            const filter = filterBtn.getAttribute('data-filter');
            window.filterHelpers(filter);
            return;
        }
        
        // Modal close buttons
        if (e.target.closest('[data-action="close-auth-modal"]')) {
            window.closeAuthModal();
            return;
        }
        
        if (e.target.closest('[data-action="close-helper-modal"]')) {
            window.closeHelperModal();
            return;
        }
        
        if (e.target.closest('[data-action="close-booking-modal"]')) {
            window.closeBookingModal();
            return;
        }
        
        if (e.target.closest('[data-action="close-cal-modal"]')) {
            window.closeCalModal();
            return;
        }
        
        if (e.target.closest('[data-action="close-cal-url-modal"]')) {
            window.closeCalUrlModal();
            return;
        }
        
        if (e.target.closest('[data-action="close-helper-application"]')) {
            window.closeHelperApplication();
            return;
        }
        
        if (e.target.closest('[data-action="close-dashboard"]')) {
            window.closeDashboard();
            return;
        }
        
        if (e.target.closest('[data-action="close-feedback-modal"]')) {
            window.closeFeedbackModal();
            return;
        }
        
        // Auth toggle
        if (e.target.closest('[data-action="toggle-auth-mode"]')) {
            e.preventDefault();
            window.toggleAuthMode();
            return;
        }
        
        // Password visibility toggle
        if (e.target.closest('[data-action="toggle-password"]')) {
            e.preventDefault();
            window.togglePasswordVisibility();
            return;
        }
        
        // Dashboard tabs
        const tabBtn = e.target.closest('[data-tab]');
        if (tabBtn) {
            const tabName = tabBtn.getAttribute('data-tab');
            window.showTab(tabName);
            return;
        }
        
        // Rating stars
        const ratingStar = e.target.closest('[data-rating]');
        if (ratingStar) {
            const rating = parseInt(ratingStar.getAttribute('data-rating'));
            window.setRating(rating);
            return;
        }
        
        // Submit feedback
        if (e.target.closest('[data-action="submit-feedback"]')) {
            window.submitFeedback();
            return;
        }
        
        // Update Cal.com URL
        if (e.target.closest('[data-action="update-calendly-url"]')) {
            window.updateCalendlyUrl();
            return;
        }
        
        // Application draft actions
        if (e.target.closest('[data-action="resume-draft"]')) {
            window.resumeDraft();
            return;
        }
        
        if (e.target.closest('[data-action="discard-draft"]')) {
            window.discardDraft();
            return;
        }
        
        if (e.target.closest('[data-action="save-draft"]')) {
            window.saveDraft();
            return;
        }
        
        // Show specific tab button
        const showTabBtn = e.target.closest('[data-action="show-tab"]');
        if (showTabBtn) {
            const tabName = showTabBtn.dataset.tab;
            window.showTab(tabName);
            return;
        }
        
        // Close dashboard and show helpers
        if (e.target.closest('[data-action="close-and-show-helpers"]')) {
            e.preventDefault();
            window.closeDashboard();
            window.showHelpers();
            return;
        }
        
        // Open Cal.com booking
        const calBtn = e.target.closest('[data-action="open-cal-booking"]');
        if (calBtn) {
            const calUrl = calBtn.dataset.calUrl;
            const helperName = calBtn.dataset.helperName;
            window.openCalBooking(calUrl, helperName);
            return;
        }
    });
    
    // Also set up keyboard event listeners for interactive elements
    body.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            const target = e.target;
            
            // Logo keyboard activation
            if (target.closest('[data-action="scroll-to-top"]')) {
                e.preventDefault();
                window.scrollToTop();
                return;
            }
        }
    });
}